import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
    namespaced: true,
    state: {
        lstCo0: [],
        co0: null,
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        hasNext: false,
        lastUpdatedRegister: null
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getCo0(state) {
            return state.co0
        },
        getCo0colecao(state) {
            return state.co0.co0colecao
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
    },
    mutations: {
        set(state, co0) {
            state.co0 = co0
            if (co0)
                state.update = true
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.co0 = null
        },
        setParamsDataTable(state, payload) {
            state.lstCo0 = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setCo0(state, co0) {
            state.co0 = co0
        },
        setLstCo0(state, lstCo0) {
            state.lstCo0 = lstCo0
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        },
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, co0colecao) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/Collection/Find/${co0colecao}`)
                .then(response => {
                    let co0 = Utils.ValidateAxiosResponse(response.data);
                    commit("set", co0)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async save({ getters, dispatch }) {
            if (getters.getUpdate) {
                return await dispatch("update")
            }
            return await dispatch("insert")
        },
        async insert({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/Products/Collection/Insert", getters.getCo0)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    commit("setCo0", null)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put("/Products/Collection/Update", getters.getCo0)
                .then(response => {
                    commit('setLastUpdatedRegister', Utils.ValidateAxiosResponse(response.data));
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Products/Collection/Delete/${getters.getCo0colecao}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    router.push("/oryxpdv/colecoes")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findList({ commit, getters, dispatch }) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Products/Collection/FindList`)
                .then(response => {
                    let lstCo0 = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstCo0", lstCo0)
                    commit("setHasNext", lstCo0.length > getters.getItemsPerPage)
                }).catch(error => {
                    commit("setLstCo0", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")
            let payload = await this._vm.$axios.get(`/Products/Collection/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setParamsDataTable", payload)
                    return true
                })
                .catch((error) => {
                    commit("setLstCo0", [])
                    commit("setSearch", "")
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            commit("setLoading", false)
            return payload
        },
    }
}